import { render, staticRenderFns } from "./recruiter-terms.vue?vue&type=template&id=7a799d30"
import script from "./recruiter-terms.vue?vue&type=script&lang=js"
export * from "./recruiter-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports